import React from "react";
import { Stack, Divider, Typography } from "@mui/material";
import LanguageSelect from "components/LanguageSelect";
import { useIntl } from "react-intl";

export default function Top() {
  const intl = useIntl();
  return (
    <>
      <Stack direction="row" justifyContent="flex-end">
        <LanguageSelect />
      </Stack>
      <Typography component="p" variant="h4" fontWeight={"bold"}>
        {intl.formatMessage({
          id: "Create Your Employer Account",
          defaultMessage: "Create Your Employer Account",
        })}
      </Typography>
      <Typography component="p" variant="h5" color="text.secondary">
        {intl.formatMessage({
          id: "Post Jobs & Search CVs in Minutes!",
          defaultMessage: "Post Jobs & Search CVs in Minutes!",
        })}
      </Typography>
      <Divider sx={{ mt: 2 }} />
    </>
  );
}
